import React from 'react';
import {
	GridActionsCellItem,
	type GridActionsCellItemProps,
	type GridRowParams,
} from '@mui/x-data-grid-premium';
import { useGlobalization } from '@Translations/useGlobalization';
import { Create, Delete } from '@mui/icons-material';

export enum GroupAction {
	Edit,
	Delete,
}

export const MenuCell = (
	params: GridRowParams,
	onActionClicked: (action: GroupAction, groupId: string) => void,
	allowDelete: boolean,
): React.ReactElement<GridActionsCellItemProps>[] => {
	const { t } = useGlobalization();
	const result = new Array<React.ReactElement<GridActionsCellItemProps>>();

	result.push(
		<GridActionsCellItem
			key={GroupAction.Edit}
			icon={<Create />}
			label={t('Edit')}
			onClick={() => {
				onActionClicked(GroupAction.Edit, params.row._id);
			}}
			showInMenu
		/>,
	);

	if (allowDelete) {
		result.push(
			<GridActionsCellItem
				key={GroupAction.Delete}
				icon={<Delete />}
				label={t('Delete')}
				onClick={() => {
					onActionClicked(GroupAction.Delete, params.row._id);
				}}
				showInMenu
			/>,
		);
	}

	return result;
};
